import React from "react";
import { useState, useEffect } from "react";
import {
  AnimatePresence,
  motion,
  useCycle,
} from "framer-motion/dist/framer-motion";

import i from "../static/css-ruleset.svg";
// import arrow from "../static/right-arrow.png";
import arrow from "../static/svg-right-arrow.svg";

export function CSSCode() {
  // const [isOpen, setIsOpen] = useState(false);
  const [variant, toggleVariant] = useCycle(
    "a",
    "b",
    "c",
    "d"
  );

  function onToggleClick() {
    toggleVariant();
  }

  useEffect(() => setInterval(onToggleClick, 1000), []);

  return (
    <div style={{ position: "relative" }}>
      {/* <button onClick={onToggleClick}>
        Toggle variant
      </button> */}
      <img src={i} alt="code-css" />
      <motion.img
        style={{
          position: "absolute",
          width: "103px",
          left: "2.7%",
          top: "33%",
          filter:
            "invert(66%) sepia(0%) saturate(4055%) hue-rotate(206deg) brightness(94%) contrast(91%)",
        }}
        src={arrow}
        variants={{
          a: { top: "33%", opacity: 0 },
          b: {
            top: "33%",
            filter:
              "invert(80%) sepia(1%) saturate(2364%) hue-rotate(337deg) brightness(76%) contrast(90%)",
          },
          c: { top: "58%" },
          d: { top: "58%", opacity: 0 },
        }}
        // transition={{
        //   duration: 2,
        //   ease: "easeInOut",
        //   times: [0, 0.2, 0.5, 0.8, 1],
        //   repeat: Infinity,
        //   repeatDelay: 1,
        // }}
        animate={variant}
      ></motion.img>
    </div>
  );
}
